<template>
  <div>
    <PropertyComponentItem
      v-if="details"
      :type="type"
      :field-details="fieldDetails"
      :item="details"
      :can-edit="false"
      :can-delete="false"
      :custom-fields="customFields"
      :col-size="6"
      :module-name="moduleName"
      disabled
    />
  </div>
</template>

<script>
import { transformAssetComponent } from '@data/asset'
import {
  customFieldAttributesTypePrefix,
  customFieldAttributesModuleName,
} from '@modules/asset/helpers/asset-custom-fields'
import { getAssetChangeLogComponentDataApi } from '../../asset-api'
import { FormComputed } from '@state/modules/form'
import PropertyComponentItem from '../propery-component-list/property-component-list-item'
import { propertyComponentFieldMap } from '../../helpers/asset'
export default {
  name: 'ViweChangeLog',
  components: { PropertyComponentItem },
  props: {
    moduleName: { type: String, required: true },
    type: { type: String, required: true },
    componentId: { type: Number, required: true },
    actionType: { type: String, default: undefined },
    componentDetailsId: { type: Number, required: true },
  },
  data() {
    this.propertyComponentFieldMap = propertyComponentFieldMap()
    return {
      details: null,
    }
  },
  computed: {
    ...FormComputed,
    fieldDetails() {
      return this.propertyComponentFieldMap[this.type]
    },
    customFields() {
      const typePrefix = customFieldAttributesTypePrefix(this.moduleName)
      return (
        ((this.assetForm || {}).fields || []).filter(
          (f) =>
            f.attributes.model ===
              customFieldAttributesModuleName(this.moduleName) &&
            (f.attributes[`${typePrefix}PropertyType`] === this.type ||
              f.attributes[`${typePrefix}ComponentType`] === this.type)
        ) || []
      )
    },
  },
  created() {
    this.getComponentDetail()
  },
  methods: {
    // getComponentDetail() {
    //   const details = transformAssetComponent(JSON.parse(this.componentDetails))
    //   this.details = details
    // },
    getComponentDetail() {
      getAssetChangeLogComponentDataApi(this.componentDetailsId).then(
        (data) => {
          const details = transformAssetComponent(
            JSON.parse(data.componentJson)
          )
          this.details = details
        }
      )
    },
  },
}
</script>
